/* tslint:disable */
/* eslint-disable */
/**
 * SEC AUDITOR API
 * Mehr unter https://sec-auditor.com
 *
 * The version of the OpenAPI document: 4.5.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import * as runtime from '../runtime';
import {
    type CreateSupportRequest200Response,
    CreateSupportRequest200ResponseFromJSON,
    CreateSupportRequest200ResponseToJSON,
} from '../models/CreateSupportRequest200Response';
import {
    type CreateSupportRequest400Response,
    CreateSupportRequest400ResponseFromJSON,
    CreateSupportRequest400ResponseToJSON,
} from '../models/CreateSupportRequest400Response';
import {
    type CreateSupportRequestRequest,
    CreateSupportRequestRequestFromJSON,
    CreateSupportRequestRequestToJSON,
} from '../models/CreateSupportRequestRequest';
import {
    type GetGlobalSettings200Response,
    GetGlobalSettings200ResponseFromJSON,
    GetGlobalSettings200ResponseToJSON,
} from '../models/GetGlobalSettings200Response';
import {
    type GetHealth200Response,
    GetHealth200ResponseFromJSON,
    GetHealth200ResponseToJSON,
} from '../models/GetHealth200Response';
import {
    type GetHealth500Response,
    GetHealth500ResponseFromJSON,
    GetHealth500ResponseToJSON,
} from '../models/GetHealth500Response';
import {
    type GetWellKnownEmailServices200ResponseInner,
    GetWellKnownEmailServices200ResponseInnerFromJSON,
    GetWellKnownEmailServices200ResponseInnerToJSON,
} from '../models/GetWellKnownEmailServices200ResponseInner';
import {
    type GetWellKnownEmailServices401Response,
    GetWellKnownEmailServices401ResponseFromJSON,
    GetWellKnownEmailServices401ResponseToJSON,
} from '../models/GetWellKnownEmailServices401Response';
import {
    type GetWellKnownEmailServices500Response,
    GetWellKnownEmailServices500ResponseFromJSON,
    GetWellKnownEmailServices500ResponseToJSON,
} from '../models/GetWellKnownEmailServices500Response';

export interface CreateSupportRequestOperationRequest {
    /**
     * 
     */
    createSupportRequestRequest: CreateSupportRequestRequest;
}

/**
 * 
 */
export class OtherApi extends runtime.BaseAPI {

    /**
     * Creates request options for createSupportRequest without sending the request
     */
    async createSupportRequestRequestOpts(requestParameters: CreateSupportRequestOperationRequest): Promise<runtime.RequestOpts> {
        if (requestParameters['createSupportRequestRequest'] == null) {
            throw new runtime.RequiredError(
                'createSupportRequestRequest',
                'Required parameter "createSupportRequestRequest" was null or undefined when calling createSupportRequest().'
            );
        }

        const queryParameters: any = {};

        const headerParameters: runtime.HTTPHeaders = {};

        headerParameters['Content-Type'] = 'application/json';

        if (this.configuration && this.configuration.accessToken) {
            const token = this.configuration.accessToken;
            const tokenString = await token("bearerAuth", []);

            if (tokenString) {
                headerParameters["Authorization"] = `Bearer ${tokenString}`;
            }
        }

        let urlPath = `/services/support/request`;

        return {
            path: urlPath,
            method: 'POST',
            headers: headerParameters,
            query: queryParameters,
            body: CreateSupportRequestRequestToJSON(requestParameters['createSupportRequestRequest']),
        };
    }

    /**
     * Create a support request. Sends an email to the configured support email address in all environments.  **Authorized Roles:** `serviceprovider`, `client`, `admin`, `reseller`, `api_user`
     */
    async createSupportRequestRaw(requestParameters: CreateSupportRequestOperationRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<CreateSupportRequest200Response>> {
        const requestOptions = await this.createSupportRequestRequestOpts(requestParameters);
        const response = await this.request(requestOptions, initOverrides);

        return new runtime.JSONApiResponse(response, (jsonValue) => CreateSupportRequest200ResponseFromJSON(jsonValue));
    }

    /**
     * Create a support request. Sends an email to the configured support email address in all environments.  **Authorized Roles:** `serviceprovider`, `client`, `admin`, `reseller`, `api_user`
     */
    async createSupportRequest(createSupportRequestRequest: CreateSupportRequestRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<CreateSupportRequest200Response> {
        const response = await this.createSupportRequestRaw({ createSupportRequestRequest: createSupportRequestRequest }, initOverrides);
        return await response.value();
    }

    /**
     * Creates request options for getGlobalSettings without sending the request
     */
    async getGlobalSettingsRequestOpts(): Promise<runtime.RequestOpts> {
        const queryParameters: any = {};

        const headerParameters: runtime.HTTPHeaders = {};

        if (this.configuration && this.configuration.accessToken) {
            const token = this.configuration.accessToken;
            const tokenString = await token("bearerAuth", []);

            if (tokenString) {
                headerParameters["Authorization"] = `Bearer ${tokenString}`;
            }
        }

        let urlPath = `/services/settings/global`;

        return {
            path: urlPath,
            method: 'GET',
            headers: headerParameters,
            query: queryParameters,
        };
    }

    /**
     * Get global settings
     */
    async getGlobalSettingsRaw(initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<GetGlobalSettings200Response>> {
        const requestOptions = await this.getGlobalSettingsRequestOpts();
        const response = await this.request(requestOptions, initOverrides);

        return new runtime.JSONApiResponse(response, (jsonValue) => GetGlobalSettings200ResponseFromJSON(jsonValue));
    }

    /**
     * Get global settings
     */
    async getGlobalSettings(initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<GetGlobalSettings200Response> {
        const response = await this.getGlobalSettingsRaw(initOverrides);
        return await response.value();
    }

    /**
     * Creates request options for getHealth without sending the request
     */
    async getHealthRequestOpts(): Promise<runtime.RequestOpts> {
        const queryParameters: any = {};

        const headerParameters: runtime.HTTPHeaders = {};

        if (this.configuration && this.configuration.accessToken) {
            const token = this.configuration.accessToken;
            const tokenString = await token("bearerAuth", []);

            if (tokenString) {
                headerParameters["Authorization"] = `Bearer ${tokenString}`;
            }
        }

        let urlPath = `/services/health`;

        return {
            path: urlPath,
            method: 'GET',
            headers: headerParameters,
            query: queryParameters,
        };
    }

    /**
     * get api health status
     */
    async getHealthRaw(initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<GetHealth200Response>> {
        const requestOptions = await this.getHealthRequestOpts();
        const response = await this.request(requestOptions, initOverrides);

        return new runtime.JSONApiResponse(response, (jsonValue) => GetHealth200ResponseFromJSON(jsonValue));
    }

    /**
     * get api health status
     */
    async getHealth(initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<GetHealth200Response> {
        const response = await this.getHealthRaw(initOverrides);
        return await response.value();
    }

    /**
     * Creates request options for getLiveness without sending the request
     */
    async getLivenessRequestOpts(): Promise<runtime.RequestOpts> {
        const queryParameters: any = {};

        const headerParameters: runtime.HTTPHeaders = {};

        if (this.configuration && this.configuration.accessToken) {
            const token = this.configuration.accessToken;
            const tokenString = await token("bearerAuth", []);

            if (tokenString) {
                headerParameters["Authorization"] = `Bearer ${tokenString}`;
            }
        }

        let urlPath = `/services/health/live`;

        return {
            path: urlPath,
            method: 'GET',
            headers: headerParameters,
            query: queryParameters,
        };
    }

    /**
     * get api liveness status (internal checks only)
     */
    async getLivenessRaw(initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<GetHealth200Response>> {
        const requestOptions = await this.getLivenessRequestOpts();
        const response = await this.request(requestOptions, initOverrides);

        return new runtime.JSONApiResponse(response, (jsonValue) => GetHealth200ResponseFromJSON(jsonValue));
    }

    /**
     * get api liveness status (internal checks only)
     */
    async getLiveness(initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<GetHealth200Response> {
        const response = await this.getLivenessRaw(initOverrides);
        return await response.value();
    }

    /**
     * Creates request options for getWellKnownEmailServices without sending the request
     */
    async getWellKnownEmailServicesRequestOpts(): Promise<runtime.RequestOpts> {
        const queryParameters: any = {};

        const headerParameters: runtime.HTTPHeaders = {};

        if (this.configuration && this.configuration.accessToken) {
            const token = this.configuration.accessToken;
            const tokenString = await token("bearerAuth", []);

            if (tokenString) {
                headerParameters["Authorization"] = `Bearer ${tokenString}`;
            }
        }

        let urlPath = `/services/email/well-known-services`;

        return {
            path: urlPath,
            method: 'GET',
            headers: headerParameters,
            query: queryParameters,
        };
    }

    /**
     * Get well-known email services from nodemailer
     */
    async getWellKnownEmailServicesRaw(initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<Array<GetWellKnownEmailServices200ResponseInner>>> {
        const requestOptions = await this.getWellKnownEmailServicesRequestOpts();
        const response = await this.request(requestOptions, initOverrides);

        return new runtime.JSONApiResponse(response, (jsonValue) => jsonValue.map(GetWellKnownEmailServices200ResponseInnerFromJSON));
    }

    /**
     * Get well-known email services from nodemailer
     */
    async getWellKnownEmailServices(initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<Array<GetWellKnownEmailServices200ResponseInner>> {
        const response = await this.getWellKnownEmailServicesRaw(initOverrides);
        return await response.value();
    }

}
